class Auth {
    canAccessAllOutlets() {
        return this.outlets().length === 0;
    }

    hasAnyPermission(...permissions) {
        if (Array.isArray(permissions[0])) {
            permissions = permissions[0];
        }

        for (var permission of permissions) {
            if (this.hasPermissionTo(permission)) {
                return true;
            }
        }

        return false;
    }

    hasPermissionTo(permission) {
        let permissions = _.get(window.slurp, 'auth.user.permissions', []);
        return _.includes(permissions, permission);
    }

    franchise() {
        let franchise = _.get(window.slurp, 'auth.franchise');

        return franchise;
    }

    billing() {
        let billing = _.get(window.slurp, 'auth.billing');

        return billing;
    }

    outlets() {
        return _.get(window.slurp, 'auth.user.outlets', []);
    }

    user() {
        let user = _.get(window.slurp, 'auth.user');
        user.last_login = moment(user.last_login);

        return user;
    }

    branch() {
        let branch = _.get(window.slurp, 'auth.branch');

        return branch;
    }
}

const AuthInstance = new Auth();

export default AuthInstance;



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/auth.js